import { Component, OnInit } from '@angular/core';
import { UserService } from '../../common/api/user.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  username = '';
  password = '';

  constructor(private userService: UserService) { }

  ngOnInit() {

  }

  login() {
    if (!this.username || this.username.length < 1) {
      alert('아이디를 입력해주세요');
      return;
    }

    if (!this.password || this.password.length < 1) {
      alert('패스워드를 입력해주세요.');
      return;
    }

    this.userService.obtainAccessToken(this.username, this.password);
  }
}




// WEBPACK FOOTER //
// /home/gitlab-runner/builds/d90c5bcf/0/gaia/gaia-ui-angular/src/app/user/login/login.component.ts